import React, { useMemo } from 'react';

const GanttChartLinesYears = ({ chartDuration, chartStart, scaleItemWidth }) => {
    const chartDays = useMemo(() => {
        return new Array(chartDuration).fill(0).map((item, index) => chartStart.clone().add(index, 'days'));
    }, [chartDuration, chartStart]);

    let secLastDay;
    let lastDay;

    return (
        <div className="gantt-chart-lines">
            {
                chartDays.map((date, index) => {
                    if (secLastDay && date.isSame(secLastDay, 'year')) {
                        return null;
                    }

                    secLastDay = date;;

                    return <div className={'line major'} key={index} style={{left: `${scaleItemWidth * index}px`}} />
                })
            }

            {
                chartDays.map((date, index) => {
                    // if (lastDay && date.isSame(lastDay, 'year')) {
                    if (lastDay && date.clone().startOf('month').isSame(lastDay.clone().startOf('month'), 'day')) {
                        return null;
                    }

                    lastDay = date;

                    return <div className="line" key={`month-${index}`} style={{left: `${scaleItemWidth * index}px`}} />
                })
            }
        </div>
    );
}

export default GanttChartLinesYears;
